module.exports = __webpack_public_path__ + "static/media/iacs.40ce29a9.png";